import { type Commands } from '../commands';
import { UUID } from '../uuid/entity';
import { MatrixValues } from './repository';
import { MatrixValue } from './entity';
import { type MatrixValueData } from './dto';

export class MatrixValuesCommands
    implements Commands<MatrixValues, MatrixValue, MatrixValueData>
{
    addAll(repo: MatrixValues, data: MatrixValueData[]): MatrixValues {
        data.forEach((matrixValueData) => {
            this.add(repo, matrixValueData);
        });
        return repo;
    }

    add(repo: MatrixValues, data: MatrixValueData): MatrixValues {
        const matrixValue = new MatrixValue({
            ...data,
        });
        repo.add(matrixValue);
        return repo;
    }

    update(repo: MatrixValues, entity: MatrixValue): MatrixValue {
        repo.update(entity);
        return entity;
    }

    remove(repo: MatrixValues, id: string): void {
        repo.remove(id);
    }

    create(repo: MatrixValues, data: Omit<MatrixValueData, 'id'>): MatrixValue {
        const uuid = new UUID();
        const matrixValue = new MatrixValue({
            id: uuid.toString(),
            ...data,
        });
        repo.add(matrixValue);
        return matrixValue;
    }

    fromJSON(entity: MatrixValue[], changeCallback: () => void): MatrixValues {
        const newMatrixValues = new MatrixValues(changeCallback);
        entity.forEach((matrixValue) => {
            newMatrixValues.add(
                new MatrixValue({
                    ...matrixValue,
                }),
            );
        });
        return newMatrixValues;
    }
}
